import store from '@/store'

/**
 * Definisce un mixin che aggiunge al componente che lo utilizza la variabile customer_styles ed il
 * caricamento della mappa degli stili personalizzati nella customer_styles stessa al created del componente.
 * Questo mixin andrebbe quindi utilizzato solo per quei componenti che hanno effettivamente necessità
 * di una personalizzazione css.
 * I dati sulla personalizzazione sono caricati nello store dal router al momento del primo accesso alla
 * pagina di login. Per maggiori informazioni vedi la funzione 'customer_control' nel router.
 */
const customerStylesMixin = {
  data: function () {
    return {
      customer_styles : null
    }
  },
  created : function () {

    this.customer_styles = this.$store.state.session_infos.customer_color_map[ this.$options.name ]

    if ( this.customer_styles != null ) {
      // Applichiamo gli stili al body della pagina li dove definiti ( per componenti
      // NON view deve essere un oggetto vuoto, vedi spiegazione nella documentazione
      // riportata nel file customerColorMap )
      for ( let key in this.customer_styles.body ) {
        document.body.style[ key ] = this.customer_styles.body[ key ];
      }
    }

  }
}

export { customerStylesMixin };
